module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Retrouvez la nouvelle version du dossier dans votre SIRH.","b":"Votre dossier a été mis à jour avec succès.","c":"Vous pouvez fermer cette page."},"en":{"a":"You can find the new version of the CV in your HRIS.","b":"Your CV has successfully been updated.","c":"You can now close this page."}}')
  delete Component.options._Ctor
}
